module.exports = __webpack_public_path__ + "static/img/sifremi-unuttum.1e5f15f.png";